import styled, { css } from 'styled-components';
import { SourceLanguageDropdownOptions as SourceLanguageDropdownOptionsComponent } from '../SourceLanguageDropdownOptions';

export const ArrowIconContainer = styled.div<{ $rotate: boolean }>(
  ({ theme, $rotate }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: ${theme.sz.s6}; // defines the size of the icon
    line-height: ${theme.sz.s6}; // defines the size of the icon

    ${$rotate &&
    css`
      transform: rotate(180deg);
    `}
  `,
);

export const Dropdown = styled.div(
  () => css`
    position: relative;
  `,
);

export const DropdownLabel = styled.button(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.sz.s2};
    background-color: unset;
    border: unset;
    color: ${theme.co.secondary0};
    ${theme.typography.heading.desktop.xxxs}
    cursor: pointer;
  `,
);

export const SourceLanguageDropdownOptions = styled(SourceLanguageDropdownOptionsComponent)(
  ({ theme }) => css`
    max-height: min(${theme.sz.sm}, calc(100vh - ${theme.sz.s20}));
    overflow-y: auto;
    position: absolute;
    left: 0;
    z-index: ${theme.zi.header};
    /* use non-theme shadow because all standard shadows overlap dropdown arrow */
    box-shadow: 0 3px 3px hsla(0, 0%, 0%, 0.14);
  `,
);
